export const ROOT = 'collapsibleListComponent';
export const NEW_PAIR_BUTTON = 'CollapsibleListNewPair_button';
export const COLLAPSIBLE_LIST_ITEM = 'collapsibleListItem';
export const COLLAPSIBLE_LIST_ITEM_TITLE = 'collapsibleListItemTitle';
export const COLLAPSIBLE_LIST_ITEM_BODY = 'collapsibleListItemBody';
export const EXPAND_BUTTON = 'collapsibleListExpandButton';
export const TOOLBAR_DELETE_BUTTON = 'blockButton_delete';
export const MODAL_ROOT = 'collapsibleListModal';
export const COLLAPSIBLE_LIST_ONE_PAIR_EXPANDED = 'onePairExpanded';
export const COLLAPSIBLE_LIST_EXPANDED_DEFAULT = {
  ALL: 'collapsibleListDefaultOptionExpanded',
  FIRST: 'collapsibleListDefaultOptionFirstExpanded',
  NONE: 'collapsibleListDefaultOptionCollapsed',
};
